module.exports = __webpack_public_path__ + "static/img/5.2aa7dd8c.png";